import { useContext } from 'react';

import ViewContext from './druid/./druid/ViewContext';

export default function useViewContext() {
  return useContext(ViewContext);
}
